var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFigma = function SvgFigma(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 288 432"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1.466 2.2h285.069V429.8H1.466z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1ABCFE",
    d: "M144 216c0-39.359 31.907-71.267 71.267-71.267s71.267 31.908 71.267 71.267c0 39.36-31.908 71.267-71.267 71.267C175.907 287.267 144 255.36 144 216"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0ACF83",
    d: "M1.466 358.534c0-39.359 31.907-71.267 71.267-71.267H144v71.267c0 39.36-31.907 71.267-71.267 71.267S1.466 397.894 1.466 358.534"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF7262",
    d: "M144 2.2v142.533h71.267c39.36 0 71.267-31.907 71.267-71.267S254.627 2.2 215.267 2.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F24E1E",
    d: "M1.466 73.466c0 39.36 31.907 71.267 71.267 71.267H144V2.199H72.733c-39.36 0-71.267 31.908-71.267 71.267"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#A259FF",
    d: "M1.466 216c0 39.36 31.907 71.267 71.267 71.267H144V144.733H72.733c-39.36 0-71.267 31.908-71.267 71.267"
  })));
};
export default SvgFigma;